let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("94fpj"), load("5cXIN"), load("ffEVr"), load("6gpUD")]).then(() => parcelRequire('dTw2J'));